import { useMutation, useQuery } from "@tanstack/react-query";
import { getNotifications, markAllNotificationsAsRead, markNotificationsAsRead } from "./requests";
import type { CustomQueryOptions, NotificationAudienceType, NotificationStatus } from "../types";

export const useGetNotifications = (
  filter?: {
    nextCursor?: string;
    prevCursor?: string;
    limit?: number;
    audience?: NotificationAudienceType;
  },
  options?: CustomQueryOptions<{ data: NotificationStatus[]; pagination: { nextCursor: string; prevCursor: string; total: number } }>
) => {
  return useQuery({
    queryKey: ['notifications', JSON.stringify(filter)],
    queryFn: () => getNotifications(filter),
    ...options
  });
};

export const useMarkNotificationAsRead = (
  onSuccess?: (data: any) => void,
  onError?: (error: Error) => void
) => {
  return useMutation({
    mutationFn: (notificationStatusIds: string[]) => markNotificationsAsRead(notificationStatusIds),
    onSuccess,
    onError
  });
};

export const useMarkAllNotificationsAsRead = (
  onSuccess?: (data: any) => void,
  onError?: (error: Error) => void
) => {
  return useMutation({
    mutationFn: () => markAllNotificationsAsRead(),
    onSuccess,
    onError
  });
};

